import React, { useState } from 'react';
import { useAppSelector } from '../store/hooks';

const Account: React.FC = () => {
  const user = useAppSelector((s) => s.auth.user);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState<'idle' | 'saving' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirm) {
      setStatus('error');
      setErrorMsg('New passwords do not match');
      return;
    }

    setStatus('saving');
    const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? '';
    const res = await fetch('/api/me', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
      body: JSON.stringify({ current_password: currentPassword, password: newPassword }),
    });

    if (res.ok) {
      setStatus('success');
      setCurrentPassword('');
      setNewPassword('');
      setConfirm('');
    } else {
      const data = await res.json();
      setStatus('error');
      setErrorMsg(data.error ?? 'Something went wrong');
    }
  };

  return (
    <div className="max-w-md">
      <h1 className="text-2xl font-bold text-white mb-1">Account</h1>
      <p className="text-gray-400 text-sm mb-8">{user?.email}</p>

      <h2 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Change password</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm text-gray-400 mb-1">Current password</label>
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            className="w-full bg-navy-800 border border-navy-700 rounded-lg px-4 py-2.5 text-white text-sm focus:outline-none focus:border-neon"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-400 mb-1">New password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="w-full bg-navy-800 border border-navy-700 rounded-lg px-4 py-2.5 text-white text-sm focus:outline-none focus:border-neon"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-400 mb-1">Confirm new password</label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            className="w-full bg-navy-800 border border-navy-700 rounded-lg px-4 py-2.5 text-white text-sm focus:outline-none focus:border-neon"
          />
        </div>

        {status === 'error' && (
          <p className="text-red-400 text-sm">{errorMsg}</p>
        )}
        {status === 'success' && (
          <p className="text-neon text-sm">Password updated.</p>
        )}

        <button
          type="submit"
          disabled={status === 'saving'}
          className="bg-neon text-army-950 font-semibold text-sm px-5 py-2.5 rounded-lg hover:brightness-110 disabled:opacity-50 transition"
        >
          {status === 'saving' ? 'Saving…' : 'Update password'}
        </button>
      </form>
    </div>
  );
};

export default Account;
